import mitt from 'mitt';
import { OrderItem } from '@libs/api-reference';

type EventTypes = {
  executeOrder: boolean;
  openIndustryGroups: void;
};

const eventBus = mitt<EventTypes>();

export const executeOrderEvent = (shouldClose: boolean) => {
  eventBus.emit('executeOrder', shouldClose);
};

export const openIndustryGroups = () => {
  eventBus.emit('openIndustryGroups');
};

export const cancelAllEvents = () => {
  for (const key of eventBus.all.keys()) {
    eventBus.off(key as keyof EventTypes);
  }
};

export default eventBus;
